module.exports = __webpack_public_path__ + "img/11.018d67c0.jpg";